module.exports = __webpack_public_path__ + "images/ad849bff8ca03398abe53e34ec50bfae.png";